// @flow
import jwtDecode from 'jwt-decode';
import { Cookies } from 'react-cookie';

/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
    const user = getLoggedInUser();
    if (!user) {
        return false;
    }
    const decoded = jwtDecode(user.token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
        console.warn('access token expired');
        return false;
    } else {
        return true;
    }
};

/**
 * Returns the logged in user
 */
const getLoggedInUser = () => {
    const cookies = new Cookies();
    const user = cookies.get('user');
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

// AccessController.GetUserToken returns id/firstName/lastName/role/token/orgId/plan
// but NOT email. The rest of the FE reads the logged-in user's email from
// state.User.profileInformation.email (see PersonalInformation.js + Topbar.js,
// loaded once on AppMenu/Topbar mount). Prefer that; fall back to a JWT claim
// decode so email-based gates work on the very first render — before
// loadProfileInformation() has resolved — and on direct URL navigation.
const emailFromUser = (user, profileInformation) => {
    if (profileInformation?.email) return profileInformation.email;
    if (user?.email) return user.email;
    if (user?.Email) return user.Email;
    if (!user?.token) return '';
    try {
        const claims = jwtDecode(user.token) || {};
        return claims.Email || claims.email || claims.sub || '';
    } catch (_) {
        return '';
    }
};

export { isUserAuthenticated, getLoggedInUser, emailFromUser };
